export default "__VITE_ASSET__290edd06__"